<template>
    <p-toolbar class="portal-header-bg z-5 h-3rem p-0 border-noround fixed top-0 w-full px-4 shadow-4">
        <template v-if="showMessagingHeader" #start>
            <img
                src="/img/logo_wide.png"
                width="400px"
                class="absolute px-8 -ml-4"
            >
        </template>
        <template v-else #start>
            <img
                v-if="isMobile"
                src="img/nethealth_logo.png"
                width="100px"
            >
            <img
                v-else
                src="/img/patient-portal-long-white.png"
                width="400px"
                class="absolute px-4 -ml-4"
            >
        </template>
        <template v-if="props.showProfile" #end>
            <div class="text-white flex align-items-center gap-3">
                <span class="hidden md:block">
                    {{ patientDetails.firstName }}
                </span>
                <p-button
                    icon="mdi mdi-account-circle-outline"
                    class="p-button-rounded p-button-text text-white text-2xl"
                    severity="info"
                    aria-controls="overlay_menu"
                    @click="toggle"
                />
                <p-menu
                    id="overlay_menu"
                    ref="buttonRef"
                    class="menu-top"
                    :model="items"
                    :popup="true"
                />
            </div>
        </template>
    </p-toolbar>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import {useRouter} from "vue-router";
import { useRootStore } from '@/store';

const props = withDefaults(defineProps<{
    showProfile?: boolean,
    showMessagingHeader?: boolean,
}>(), {
    showProfile: false,
    showMessagingHeader: false,
});

const rootStore = useRootStore();
const router = useRouter();
const isMobile = computed(() => rootStore.state.isMobile);
const patientDetails = computed(() => rootStore.state.currentPatient);
const setFacilityId = () => rootStore.dispatch('setFacilityId');
const setAccessToken = () => rootStore.dispatch('setAccessToken');

const buttonRef = ref();
const items = ref([
    {
        label: 'Account Settings',
        icon: 'pi pi-cog',
        command: async () => {
            router.push({ path: '/settings' });
        }
    },
    {
        label: 'Log Out',
        icon: 'pi pi-sign-out',
        command: async () => {
            await setAccessToken();
            await setFacilityId();
            router.push({ path: '/login' });
        }
    }
]);

function toggle(event: Event) {
    buttonRef.value.toggle(event)
}
</script>
<style lang="scss" scoped>
.portal-header-bg {
  background-color: rgb(51, 63, 72);
}
.menu-top {
    top: 43px !important;
}
</style>

